import React from 'react';
import styled from 'styled-components';
import WeekDaySelectorRadio from './WeekDaySelectorRadio';
import { breakpoint } from '../../theme/breakpoints';
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${breakpoint.md`
    flex-direction: row;
  `}
  justify-content: space-between;
`;
const RadioRow = styled.div`
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  flex-grow: 1;
`;
const TopRow = styled(RadioRow)`
  ${breakpoint.md`
    justify-content: space-around;
  `}
  justify-content: space-between;
`;
export const WeekDaySelector = ({
  value,
  disabled = false,
  onClick,
  weekdays,
  ...props
}) => {
  const midIndex = Math.ceil(weekdays.length / 2);
  return /*#__PURE__*/React.createElement(Wrapper, props, /*#__PURE__*/React.createElement(TopRow, null, weekdays.slice(0, midIndex).map((day, index) => {
    return /*#__PURE__*/React.createElement(WeekDaySelectorRadio, {
      disabled,
      onClick,
      key: day.key,
      index: index,
      value: value,
      label: day.label,
      dataTestId: day.key,
      name: day.key
    });
  })), /*#__PURE__*/React.createElement(RadioRow, null, weekdays.slice(midIndex).map((day, index) => {
    return /*#__PURE__*/React.createElement(WeekDaySelectorRadio, {
      disabled,
      onClick,
      key: day.key,
      index: index + midIndex,
      value: value,
      label: day.label,
      dataTestId: day.key,
      name: day.key
    });
  })));
};
export default WeekDaySelector;
//# sourceMappingURL=index.js.map